import React from "react";

// Shown in place of an infinite loading spinner when a fetch fails.
const ErrorState = ({
  message = "콘텐츠를 불러오지 못했습니다.",
  onRetry,
  fullScreen = true,
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      gap: "14px",
      padding: "40px 24px",
      minHeight: fullScreen ? "60vh" : "auto",
      color: "#2b2b2e",
    }}
  >
    <strong style={{ fontSize: "18px" }}>{message}</strong>
    <p style={{ fontSize: "13px", color: "#888", margin: 0 }}>
      잠시 후 다시 시도해주세요.
    </p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        style={{
          padding: "8px 22px",
          background: "#8D54E6",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        다시 시도
      </button>
    )}
  </div>
);

export default ErrorState;
